import { render, staticRenderFns } from "./CaseStudies.vue?vue&type=template&id=0b37d046&scoped=true"
import script from "./CaseStudies.vue?vue&type=script&lang=js"
export * from "./CaseStudies.vue?vue&type=script&lang=js"
import style0 from "./CaseStudies.vue?vue&type=style&index=0&id=0b37d046&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b37d046",
  null
  
)

export default component.exports